<app-segov-sigepo-portal-body
[ocultarFooter]="isFullscreen">
  <app-segov-sigepo-header-section
  [RouteStack]="RouteStack" />

  <div class="search-bar-line-edicao-dia-bg dropdown-e-pesquisa row" style="min-height: unset !important;">
    <div class="col-xl-3 col-12 space-left-column">
      <div
      class="coluna-card-data"
      style="display: grid;
      background: url('images/bandeira-minas-gerais-header.png') no-repeat, linear-gradient(90deg, rgb(0, 0, 0) 0%, rgb(0, 0, 0, 0.7) 60%, rgb(202, 202, 202, 0.1) 100%);
      background-size: cover;
      background-blend-mode: hue;
      background-position: 0% 20%;">
        <span style="font-weight: 600; font-size: large; color: white;">Edição do dia</span>
        <app-dropdown-calendario [visualizacaoPdf]="!modoHtml" [dataApresentada]="ultimaData" [Cronogramas]="cronogramas"
          (redirecionarUltimaEdicao)="getUltimaEdicaoPorCliqueCalendario()"
          (dataClicada)="obterData($event)" (alternarMes)="trocouMes($event)"></app-dropdown-calendario>
      </div>
    </div>
    <div class="col-xl-9 col-12 space-right-column">
      <lib-segov-sigepo-rounded-search-bar
        (click)="showModalPesquisa()"
        (keyup.enter)="showModalPesquisa()"
        [customSearchIconStyle]="'color: var(--tom-1-jornal); padding-right: 8px; font-size: 30px'"
        [customInputStyle]="'height: 72px; border-radius: 5px'" [placeholder]="'Clique aqui para efetuar a pesquisa avançada'">
      </lib-segov-sigepo-rounded-search-bar>
    </div>
  </div>

  @if (modoHtml) {
    <div class="row conteudo-html-edicao">
      <aside class="col-xl-3 col-12 cadernos-html" aria-label="Cadernos da edição">
        @if (carregandoSumarioHtml && !possuiCadernosSumario()) {
          <div class="sumario-status" output="status">Carregando sumário...</div>
        }
        @if (edicaoOrdinariaHtml; as edicaoOrdinaria) {
          @for (caderno of obterSumarioEdicao(edicaoOrdinaria.id)?.cadernos ?? []; track caderno.cadernoEdicaoId) {
            <section class="caderno-sumario" [class.aberto]="cadernoSumarioEstaAberto(edicaoOrdinaria.id, caderno.cadernoEdicaoId)">
              <button type="button"
                class="caderno-sumario-cabecalho"
                [attr.aria-expanded]="cadernoSumarioEstaAberto(edicaoOrdinaria.id, caderno.cadernoEdicaoId)"
                (click)="alternarCadernoSumario(edicaoOrdinaria.id, caderno)">
                <span>{{ caderno.nome }}</span>
                <i class="fas"
                  [class.fa-chevron-up]="cadernoSumarioEstaAberto(edicaoOrdinaria.id, caderno.cadernoEdicaoId)"
                  [class.fa-chevron-down]="!cadernoSumarioEstaAberto(edicaoOrdinaria.id, caderno.cadernoEdicaoId)"
                  aria-hidden="true"></i>
              </button>
              @if (cadernoSumarioEstaAberto(edicaoOrdinaria.id, caderno.cadernoEdicaoId)) {
                <div class="caderno-sumario-conteudo">
                  <app-sumario-publicacao-html
                    [edicaoId]="edicaoOrdinaria.id"
                    [caderno]="caderno"
                    [filtroSelecionado]="obterFiltroCaderno(edicaoOrdinaria.id, caderno.cadernoEdicaoId)"
                    (filtroAlterado)="aplicarFiltroSumarioHtml($event)" />
                </div>
              }
            </section>
          }
        }
        @for (edicaoExtra of edicoesExtrasHtml; track edicaoExtra.id) {
          @if (obterSumarioEdicao(edicaoExtra.id); as sumarioExtra) {
            @for (caderno of sumarioExtra.cadernos; track caderno.cadernoEdicaoId) {
              <section class="caderno-sumario" [class.aberto]="cadernoSumarioEstaAberto(edicaoExtra.id, caderno.cadernoEdicaoId)">
                <button type="button"
                  class="caderno-sumario-cabecalho"
                  [attr.aria-expanded]="cadernoSumarioEstaAberto(edicaoExtra.id, caderno.cadernoEdicaoId)"
                  (click)="alternarCadernoSumario(edicaoExtra.id, caderno)">
                  <span>{{ obterTituloCadernoExtra(caderno) }}</span>
                  <i class="fas"
                    [class.fa-chevron-up]="cadernoSumarioEstaAberto(edicaoExtra.id, caderno.cadernoEdicaoId)"
                    [class.fa-chevron-down]="!cadernoSumarioEstaAberto(edicaoExtra.id, caderno.cadernoEdicaoId)"
                    aria-hidden="true"></i>
                </button>
                @if (cadernoSumarioEstaAberto(edicaoExtra.id, caderno.cadernoEdicaoId)) {
                  <div class="caderno-sumario-conteudo">
                    <app-sumario-publicacao-html
                      [edicaoId]="edicaoExtra.id"
                      [caderno]="caderno"
                      [filtroSelecionado]="obterFiltroCaderno(edicaoExtra.id, caderno.cadernoEdicaoId)"
                      (filtroAlterado)="aplicarFiltroSumarioHtml($event)" />
                  </div>
                }
              </section>
            }
          }
        }
        @if (possuiCadernosSumario()) {
          <button type="button" class="edicao-completa" (click)="selecionarEdicaoCompletaHtml()">
            Edição Completa
          </button>
        }
      </aside>
      <main class="col-xl-9 col-12 conteudo-html">
        @if (carregandoEdicaoHtml) {
          <div class="estado-html" role="status">Carregando edição...</div>
        } @else if (erroEdicaoHtml === mensagensEdicaoHtml.SemEdicaoTitulo) {
          <ng-container *ngTemplateOutlet="mensagemSemEdicao"></ng-container>
        } @else if (erroEdicaoHtml) {
          <div class="estado-html estado-html--erro" role="alert">
            <h2>{{ erroEdicaoHtml }}</h2>
          </div>
        } @else if (edicaoHtmlAtual && cadernoHtmlAtual) {
          <app-materias-html
            [edicao]="edicaoHtmlAtual"
            [caderno]="cadernoHtmlAtual"
            [materias]="materiasHtml"
            [carregando]="carregandoMateriasHtml"
            [erro]="erroMateriasHtml"
            [possuiProximaPagina]="paginaHtml < totalPaginasHtml"
            (carregarMais)="carregarMaisMateriasHtml()" />
        }
      </main>
    </div>
  } @else {
  <div class="row conteudo-pdf-sumario">
    @if(PesquisaSumarioFinalizada || PesquisaPdfPorNomeFinalizada) {
    <div *ngIf="!isFullscreen" class="col-xl-3 col-12 space-left-pdf-column">
      @for(caderno of cadernosObtidos; track $index){
        <app-diario-accordion (click)="obterIdSecaoClicada(caderno?.id)" (keyup)="obterIdSecaoClicada(caderno?.id)" [style]="'padding-bottom: 1rem'" [possuiConteudo]="caderno?.secoes && caderno?.secoes.length > 0"  [titulo]="caderno?.descricao">
          <ul style="list-style-type: none;">
            @for(sumario of caderno?.secoes; track $index){
            <li tabindex="0" (click)="atualizarPagina(sumario?.paginaInicial)" (keyup.enter)="atualizarPagina(sumario?.paginaInicial)"
            class="item-sumario" (mouseenter)="exibirPaginaSecao(sumario)" (mouseleave)="ocultarPaginaSecao(sumario)">
              {{sumario?.descricao}}
              <span class="item-pagina-sumario" [hidden]="!sumario?.exibirNumeroPagina"> Pág.{{sumario?.paginaInicial}}</span>
            </li>
            }
          </ul>
        </app-diario-accordion>
      }
    </div>
    @if(dadosSumario || PesquisaPdfPorNomeFinalizada) {
      @if(!arquivoErro) {
        <div [class]="classesPDF()">
          @if(arquivoOutputDtoAtual?.arquivoUnico || PesquisaPdfPorNomeFinalizada) {
            <lib-segov-sigepo-pdf-visualizador
            [autoResize]="false"
            [showBorders]="false"
            [textoPesquisa]="textoPesquisa"
            [fitToPage]="true"
            [nomeArquivo]="nomeArquivo"
            [src]="pdfBase64" [page]="paginaAtual"
            (dadosAbertos)="obterDadosAbertos()"
            (clicouBotaoFullscreen)="isFullscreen = $event"
            (obterDadosParaCopia)="copiarLinkPaginaAtual($event)"/>
          } @else {
            <lib-segov-sigepo-pdf-visualizador [src]="pdfBase64" [page]="paginaAtual"
            [totalPages]="arquivoOutputDtoAtual?.totalPaginas"
            [arquivoUnico]="arquivoOutputDtoAtual?.arquivoUnico"
            [nomeArquivo]="nomeArquivo"
            [fitToPage]="true"
            [stickToPage]="false"
            [renderText]="false"
            (dadosAbertos)="obterDadosAberto()"
            (paginaPosterior)="atualizaPaginaPorNavegacao($event)"
            (paginaAnterior)="atualizaPaginaPorNavegacao($event)"
            (trocouPaginaPorInput)="atualizaPaginaPorInput($event)"
            (clicouBotaoFullscreen)="isFullscreen = $event"
            (obterDadosParaCopia)="copiarLinkPaginaAtual($event)"/>
          }
        </div>
        } @else {
          <h2 class="col-xl-9 col-12" style="color: var(--tom-2-jornal); padding-bottom: 1rem">{{arquivoErro}}</h2>
        }
      } @else {
        @if(!arquivoErro) {
          <div class="col-xl-9 col-12">
            <ng-container *ngTemplateOutlet="mensagemSemEdicao"></ng-container>
          </div>
        } @else {
          <h2 class="col-xl-9 col-12" style="color: var(--tom-2-jornal); padding-bottom: 1rem">{{arquivoErro}}</h2>
        }
      }
    } @else {
    <div class="col-12 selecione-uma-data">
      <span style="color: black;">Selecione uma data no calendário.</span>
    </div>
    }
  </div>
  }

</app-segov-sigepo-portal-body>

<ng-template #mensagemSemEdicao>
  <section class="mensagem-sem-edicao" aria-live="polite">
    <h2>{{ mensagensEdicaoHtml.SemEdicaoTitulo }}</h2>
    <div class="mensagem-sem-edicao__texto">
      <p><strong>{{ mensagensEdicaoHtml.SemEdicaoPeriodoAtualDestaque }}</strong> {{ mensagensEdicaoHtml.SemEdicaoPeriodoAtual }}</p>
      <p>{{ mensagensEdicaoHtml.SemEdicaoPublicacao }}</p>
      <p><strong>{{ mensagensEdicaoHtml.SemEdicaoDigitalizacaoDestaque }}</strong> {{ mensagensEdicaoHtml.SemEdicaoDigitalizacao }}</p>
      <p>{{ mensagensEdicaoHtml.SemEdicaoAtendimento }}</p>
      <div class="container-botao-ver-canais">
        <lib-segov-sigepo-rounded-button [baseStyle]="'segov-rounded-button-with-border'" [type]="'button'"
          [width]="'320px'" [customStyle]="'border-radius: 5px;'"
          (click)="goToAtendimentos()" (keyup.enter)="goToAtendimentos()">
          Ver canais de Atendimento
        </lib-segov-sigepo-rounded-button>
      </div>
    </div>
  </section>
</ng-template>

<lib-segov-sigepo-modal
    [showModal]="exibeModalPesquisa"
    [maxWidthExterno]="'1080px'"
    [hasHeader]="false"
    [closeIconStyle]="'color:white'"
    [modalBodyStyle]="'padding: 0'"
    [modalCustomStyle]="'background-color: rgb(1,1,1,0.4)'"
    [showCloseIcon]="true"
    (closedModal)="exibeModalPesquisa = false">
    <app-segov-sigepo-pesquisa-form body
      (dadosPesquisaFormOutput)="goToPesquisa($event)"/>
</lib-segov-sigepo-modal>
